import React from 'react';
import MUIDataTable from 'mui-datatables';
import Moment from 'react-moment';

class ReportsDataTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.data,
      title: props.title
    };
  }

  render() {
    const columns = [
      {
        name: 'campaingName',
        label: 'Campaign Name',
        options: {
          filter: true
        }
      },
      {
        name: 'campaingCreateDate',
        label: 'Date Sent',
        options: {
          filter: true,
          customBodyRender: value => {
            return <Moment format='MMMM Do YYYY, h:mm a'>{value}</Moment>;
          },
          sort: true,
          options: {
            sortDirection: 'desc',
          }
        }
      },
      {
        name: 'peopleOnCreation',
        label: 'People on Creation',
        options: {
          filter: true
        }
      }
    ];

    const data = this.props.items;

    const options = {
      filter: true,
      selectableRows: 'none',
      selectableRowsOnClick: false,
      filterType: 'multiselect',
      responsive: 'stacked',
      rowsPerPage: 10,
      sortOrder: {
        name: 'campaingCreateDate',
        direction: 'desc',
      },
      viewColumns: false
    };

    return (
      <MUIDataTable
        title={this.props.title}
        data={data}
        columns={columns}
        options={options}
      />
    );
  }
}

export default ReportsDataTable;
